import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import * as fromStore from "../../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {Website} from '../../website';

@Injectable()
export class HostingVisitsByWebsiteByDateResolver implements Resolve<null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;

      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((loaded: Boolean) => !!loaded),
          switchMap(() => this._store.select(fromStore.getWebsite(websiteId))),
          first()
        )
        .subscribe((website: Website) => {
          if (website.domain_hash) {
            this._store.select(fromStore.getHostingVisitsByWebsiteByDateLoaded(websiteId))
              .pipe(
                filter((loaded: boolean): boolean => loaded),
                switchMap(() => this._store.select(fromStore.getHostingVisitsByWebsiteByDateMap(websiteId))),
                first()
              )
              .subscribe((visitsMap: any) => {
                const visits: any = visitsMap && visitsMap.entities;
                if (visits) {
                  resolve(visits);
                }
                else {
                  resolve(null);
                }
              });
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
